import { render, staticRenderFns } from "./EditarDatoExtendidoModal.vue?vue&type=template&id=2a3ebb53&scoped=true&"
import script from "./EditarDatoExtendidoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarDatoExtendidoModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditarDatoExtendidoModal.vue?vue&type=style&index=0&id=2a3ebb53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ebb53",
  null
  
)

export default component.exports